import { useMeeting } from "@videosdk.live/react-sdk";
import { setMeetingJoined, setVideoTime } from "../slice/authSlice";
import {
  startConnectionWithGameCodeAndUserId,
  decreaseVideoMinutesRuntime,
} from "../common/game/GameControl";
import LogRocket from "../util/LogRocketUtil";

/**
 * useVideoMeeting - Manages VideoSDK meeting lifecycle and video minutes tracking.
 * 
 * US-007-S1B-EXTRACT-VIDEO-LOGIC-002
 * 
 * This hook wraps the VideoSDK useMeeting hook and provides:
 * - Meeting join/leave lifecycle callbacks
 * - Video minutes tracking and billing (for creators)
 * - Automatic video runout notification triggers
 * 
 * NOTE: This hook must be used inside a MeetingProvider context.
 * 
 * @param {Object} params - Hook parameters
 * @param {Object} params.stateRef - React ref containing current game/asset state
 * @param {Function} params.dispatch - Redux dispatch function
 * @param {Function} params.setTimerId - Setter for timer ID state
 * @param {Function} params.setTotalMinutes - Setter for total minutes state
 * @param {Function} params.setVideoMinutesRunoutModalOpen - Setter for video runout modal
 * @param {string} params.gameCode - Current game code
 * @param {string} params.userId - Current user ID
 * @returns {Object} meetingAPI - The VideoSDK meeting API object
 */
export function useVideoMeeting({
  stateRef,
  dispatch,
  setTimerId,
  setTotalMinutes,
  setVideoMinutesRunoutModalOpen,
  gameCode,
  userId,
}) {
  const meetingAPI = useMeeting({
    onMeetingJoined: () => {
      console.log("[LOG][Video] onMeetingJoined", { gameCode, userId, isCreator: stateRef.current.isCreator });
      dispatch(setMeetingJoined(true));
      
      // Only creators track video minutes and billing
      if (stateRef.current.isCreator) {
        let intervalId = setInterval(async () => {
          console.log("Outside===Open");
          decreaseVideoMinutesRuntime(
            stateRef.current.gameHash,
            dispatch,
            setVideoTime
          );
          console.log(
            `Active Players: ${stateRef.current.minutes} stateRef.current.minutes +${stateRef.current.gameHash.ActivePlayers.length} stateRef.current.gameHash.ActivePlayers.length`
          );
          console.log(
            stateRef.current.minutes +
              stateRef.current.gameHash.ActivePlayers.length
          );
          console.log(
            `${parseInt(
              stateRef.current.asset.Tokens
            )} parseInt(stateRef.current.asset.Tokens)-${parseInt(
              10 * stateRef.current.gameHash.ActivePlayers.length
            )} parseInt(10 * stateRef.current.gameHash.ActivePlayers.length)`
          );
          console.log(
            parseInt(stateRef.current.asset.Tokens) -
              parseInt(10 * stateRef.current.gameHash.ActivePlayers.length)
          );
          console.log("Outside===Closed");
          
          // Check if video minutes are about to run out
          if (
            stateRef.current.minutes +
              stateRef.current.gameHash.ActivePlayers.length >=
            parseInt(stateRef.current.asset.Tokens) -
              parseInt(10 * stateRef.current.gameHash.ActivePlayers.length)
          ) {
            console.log("Inside===Open");
            console.log(
              `${stateRef.current.minutes} stateRef.current.minutes +${stateRef.current.gameHash.ActivePlayers.length} stateRef.current.gameHash.ActivePlayers.length`
            );
            console.log(
              stateRef.current.minutes +
                stateRef.current.gameHash.ActivePlayers.length
            );
            console.log(
              `${parseInt(
                stateRef.current.asset.Tokens
              )} parseInt(stateRef.current.asset.Tokens)-${parseInt(
                10 * stateRef.current.gameHash.ActivePlayers.length
              )} parseInt(10 * stateRef.current.gameHash.ActivePlayers.length)`
            );
            console.log(
              parseInt(stateRef.current.asset.Tokens) -
                parseInt(10 * stateRef.current.gameHash.ActivePlayers.length)
            );
            console.log("Inside===Closed");
            
            // Show video runout modal and notify other players
            setVideoMinutesRunoutModalOpen(true);
            await startConnectionWithGameCodeAndUserId(gameCode, userId).then(
              (result) => {
                console.log(result);
                result
                  .invoke(
                    "AlertNotifictionVideo",
                    "video will end in 2 minutes. the game will stay active.the host may purchase more video credits to continue"
                  )
                  .catch((err) => console.error(err));
              }
            );
          }

          // Calculate estimated minutes
          setTotalMinutes(
            stateRef.current.minutes +
              stateRef.current.gameHash.ActivePlayers.length
          );
        }, 1000 * 60);
        setTimerId(intervalId);
      }
      LogRocket.log("Joined Meeting", meetingAPI.meetingId);
    },
    
    onMeetingLeft: () => {
      console.log("[LOG][Video] onMeetingLeft", { gameCode, userId });
      dispatch(setMeetingJoined(false));
      LogRocket.log("Left Meeting", meetingAPI.meetingId);
      clearInterval(stateRef.current.timerId);
    },
    
    onParticipantLeft: (participant) => {
      console.log("[LOG][Video] onParticipantLeft", { participantId: participant?.id, gameCode });
      LogRocket.log("Participant Left Meeting", meetingAPI.meetingId);
    },
  });

  return meetingAPI;
}
